import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Create a custom hook for navigation
const useLogout = () => {
    const navigate = useNavigate();

    const logout = () => {
        localStorage.clear();
        localStorage.setItem("attesta_timeline_logout", Date.now());
        navigate("/");
    };

    return logout;
};

// Add request interceptor to add token in the header
axios.interceptors.request.use(
    function (config) {
        const token = localStorage.getItem('authtoken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle 401 errors and log the user out
axios.interceptors.response.use(
    function (response) {
        // console.log('Response:', response); // Log the response to the console
        return response; // Return the response if no error
    },
    function (error) {
        if (error.response) {
            // console.log('Error response:', error.response); // Log the error response
        }
        if (error.response && error.response.data.status === 401) {
            //  console.log('Error response:', error.response.data.status);
            // Handle 401 Unauthorized errors
            localStorage.clear();
            localStorage.setItem("attesta_timeline_logout", Date.now());
            window.location.href = '/'; 
        }
        return Promise.reject(error);
    }
);
